module.exports = __webpack_public_path__ + "static/media/img3_1.304420ff.png";